module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    staticClass: "modal--small",
    attrs: {
      "show": _vm.show,
      "data-backdrop": "static",
      "clickToClose": "false",
      "data-keyboard": "false"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "modal-header"
  }, [_c('h3', {
    staticStyle: {
      "color": "#000000"
    }
  }, [_vm._v("Dodavanje kupona za - " + _vm._s(_vm.title))]), _vm._v(" "), _c('i', {
    staticClass: "ti-close",
    on: {
      "click": _vm.close
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("Trenutno stanje")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('span', [_vm._v("\n                    " + _vm._s(_vm.currentGreen) + "\n                    "), _c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("Dodaj kupone")]), _vm._v(" "), _c('div', [_c('br'), _vm._v(" "), _c('div', [_c('button', {
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.minusVoucherWith('VOUCHER_GREEN', 5000)
      }
    }
  }, [_vm._v("-5000")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.minusVoucherWith('VOUCHER_GREEN', 1000)
      }
    }
  }, [_vm._v("-1000")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.minusVoucherWith('VOUCHER_GREEN', 50)
      }
    }
  }, [_vm._v("-50")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "25px"
    },
    on: {
      "click": function($event) {
        return _vm.minusVoucher('VOUCHER_GREEN')
      }
    }
  }, [_vm._v("-")]), _vm._v(" "), _c('span', [_vm._v("\n                          " + _vm._s(_vm.greenVoucher) + "\n                          "), _c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "25px"
    },
    on: {
      "click": function($event) {
        return _vm.plusVoucher('VOUCHER_GREEN')
      }
    }
  }, [_vm._v("+")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "30px"
    },
    on: {
      "click": function($event) {
        return _vm.plusVoucherWith('VOUCHER_GREEN', 50)
      }
    }
  }, [_vm._v("+50")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.plusVoucherWith('VOUCHER_GREEN', 1000)
      }
    }
  }, [_vm._v("+1000")]), _vm._v(" "), _c('button', {
    staticStyle: {
      "width": "40px"
    },
    on: {
      "click": function($event) {
        return _vm.plusVoucherWith('VOUCHER_GREEN', 5000)
      }
    }
  }, [_vm._v("+5000")])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('p', {
    staticStyle: {
      "cursor": "pointer"
    }
  }, [_vm._v("Stanje nakon dodavanja")]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('div', [_c('span', [_vm._v("\n                    " + _vm._s(_vm.currentGreen + _vm.greenVoucher) + "\n                    "), _c('img', {
    staticStyle: {
      "width": "20px",
      "height": "20px"
    },
    attrs: {
      "src": require("../assets/img/coin.png")
    }
  })])])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.hasError.length !== 0),
      expression: "hasError.length !== 0"
    }],
    staticClass: "foo"
  }, [_c('div', [_c('p', {
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v(_vm._s(_vm.hasError))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-footer text-center"
  }, [(!_vm.isLoading) ? _c('input', {
    staticClass: "input",
    staticStyle: {
      "background": "#2b542c"
    },
    attrs: {
      "type": "button",
      "placeholder": "Sačuvaj",
      "name": "azuriraj",
      "value": "Sačuvaj"
    },
    on: {
      "click": function($event) {
        return _vm.addCupons()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('div', {
    staticClass: "foo"
  }, [_c('div', {
    staticClass: "loader",
    staticStyle: {
      "width": "36px",
      "height": "36px"
    }
  })]) : _vm._e()])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-a67d5cc6!./~/vue-loader/lib/selector.js?type=template&index=0!./src/modals/AddCompanyCupons.vue
// module id = 507
// module chunks = 1